import Spinner from 'react-bootstrap/Spinner';
import styles from './index.module.scss';

export const Loader = () => {
    return (
        <div className={styles.wrapper}>
            <Spinner animation="grow" className={styles.loader}/>
        </div>
    );
};
